import produce from "immer";
import actionTypes from "../actionTypes/log";

const initialState = {};

export default function editor(state = initialState, { payload, type }) {
  const nextState = produce(state, (draft) => {
    switch (type) {
      case actionTypes.UPDATE_LOG: {
        const { problemId, status } = payload;
        if (state[problemId]) {
          draft[problemId].unshift(status);
        } else {
          draft[problemId] = [status];
        }
        break;
      }
      default:
    }
  });

  return nextState;
}
